module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-additional-integrations-3a321b324a635d70b73886c9df7a811a.png";